// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "companies-frontend-b21b3468/" + "4ec6b7b90488f186" + ".css";
};